<template>
  <div class="custom-container">
    <div class="font-weight-bold mb-3">
      {{ $t(`common.${flag === 0 ? 'pre' : 'post'}_course_report`) }}
    </div>

    <div class="default-question mb-3">
      <div class="default-question-header">
        {{ $t('course_report.fix_question') }}
      </div>
      <div
        v-for="(question, index) in questions"
        :key="question.no"
        class="d-flex mb-3"
      >
        <div class="question-number font-weight-medium">
          ({{ $t('course_report.question') }}{{ index + 1 }})
        </div>
        <div class="question-text">
          {{ question.question }}
        </div>
      </div>
    </div>

    <div class="mb-3 d-flex justify-space-between align-items-end">
      <div class="dynamic-question">
        {{ $t('course_report.custom_question', { number: questions?.length + 1 }) }}
      </div>
      <div>
        <div>
          {{ $t('course_report.required') }}
        </div>
        <div>
          <v-switch
            v-model="isRequired"
            color="primary"
            class="mt-0"
            hide-details
          />
        </div>
      </div>
    </div>

    <div class="pa-3 mx-3">
      <v-textarea
        ref="customQuestion"
        v-model="originalQuestion"
        :disabled="softLoading"
        counter
        :rules="questionnaireMaxLengthRule"
        dense
        rows="1"
        outlined
        no-resize
        auto-grow
      />
    </div>
    <div class="pa-3 mx-3">
      <v-btn
        :loading="softLoading"
        fill
        color="primary white--text"
        @click="onSave"
      >
        {{ $t('common.save') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    questionnaires: {
      required: true,
      type: Object,
      default: () => {
        return {
          original_question: ''
        }
      }
    },
    softLoading: {
      required: true,
      type: Boolean
    },
    flag: {
      required: true,
      type: Number,
      validator: val => [0, 1].includes(val)
    },
    staticQuestionnaires: {
      required: true,
      type: Array
    }
  },

  data() {
    return {
      isRequired: this.questionnaires.original_question_required_flg,
      originalQuestion: this.questionnaires.original_question,
      questions: this.staticQuestionnaires,
    }
  },

  computed: {
    questionnaireMaxLengthRule() {
      const MAX_LENGTH = 160
      return [
        v => v.length <= MAX_LENGTH || this.$t('common.maximum_text', { length: MAX_LENGTH })
      ]
    }
  },

  watch: {
    questionnaires: {
      deep: true,
      handler() {
        this.isRequired = this.questionnaires.original_question_required_flg
        this.originalQuestion = this.questionnaires.original_question == null ? '' : this.questionnaires.original_question
      }
    },

    staticQuestionnaires: {
      deep: true,
      handler() {
        this.questions = this.staticQuestionnaires
      }
    }
  },

  created() {
    this.originalQuestion = this.questionnaires.original_question == null ? '' : this.questionnaires.original_question
  },

  methods: {
    onSave() {
      const data = {
        original_question: this.originalQuestion,
        is_required: this.isRequired,
        seminar_division_id: this.questionnaires.seminar_division_id,
        report_division_id: this.questionnaires.report_division_id,
      }

      if (this.$refs.customQuestion.valid) {
        this.hasError = this.$refs.customQuestion.hasError
        this.$emit('update', data)
      }
    }
  }
}
</script>

<style scoped>
.custom-container {
  border: 1px solid #D1D1D1;
  background-color: #fff;
  padding: 16px;
  overflow: hidden;
}

.default-question {
  background-color: #F1F1F3;
  border: 1px;
  border-radius: 3px;
  padding: 1rem;
}

.question-number {
  flex: 0 0 50px;
}

.question-text {
  flex: auto;
}

.default-question-header {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.dynamic-question {
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  padding-right: 1rem;
}
</style>
